import { IAppState } from '../toolbarState';
import { StateV5 } from './5_migrate_aktionsnachlass.interface';

export const migrateAktionsnachlass = (
  previousState: StateV5,
  newVersion: number,
  currentState: IAppState,
): StateV5 => {
  const foundKooperation = currentState.transientState.kooperationen?.some(
    k => k?.code === previousState.aktionsnachlassCode?.code,
  );
  if (!foundKooperation) {
    previousState.aktionsnachlassCode = { code: null, name: null };
  }
  return {
    ...previousState,
    version: newVersion,
  };
};
